/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './tumor-board-participant-outcome.reducer';

export const TumorBoardParticipantOutcome = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const tumorBoardParticipantOutcomeList = useAppSelector(state => state.tumorBoardParticipantOutcome.entities);
  const loading = useAppSelector(state => state.tumorBoardParticipantOutcome.loading);
  const totalItems = useAppSelector(state => state.tumorBoardParticipantOutcome.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="tumor-board-participant-outcome-heading" data-cy="TumorBoardParticipantOutcomeHeading">
        <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.home.title">Tumor Board Participant Outcomes</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/tumor-board-participant-outcome/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.home.createLabel">
              Create new Tumor Board Participant Outcome
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.tumorBoardParticipantOutcome.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {tumorBoardParticipantOutcomeList && tumorBoardParticipantOutcomeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('joinedAt')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.joinedAt">Joined At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('joinedAt')} />
                </th>
                <th className="hand" onClick={sort('leftAt')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.leftAt">Left At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('leftAt')} />
                </th>
                <th className="hand" onClick={sort('memberId')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.memberId">Member Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('memberId')} />
                </th>
                <th className="hand" onClick={sort('memberRole')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.memberRole">Member Role</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('memberRole')} />
                </th>
                <th className="hand" onClick={sort('skipped')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.skipped">Skipped</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('skipped')} />
                </th>
                <th className="hand" onClick={sort('opinionSummary')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.opinionSummary">Opinion Summary</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('opinionSummary')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.boardMember">Board Member</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.occurrence">Occurrence</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.patient">Patient</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {tumorBoardParticipantOutcomeList.map((tumorBoardParticipantOutcome, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/tumor-board-participant-outcome/${tumorBoardParticipantOutcome.id}`} color="link" size="sm">
                      {tumorBoardParticipantOutcome.id}
                    </Button>
                  </td>
                  <td>{tumorBoardParticipantOutcome.joinedAt}</td>
                  <td>{tumorBoardParticipantOutcome.leftAt}</td>
                  <td>{tumorBoardParticipantOutcome.memberId}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.MemberRole.${tumorBoardParticipantOutcome.memberRole}`} />
                  </td>
                  <td>{tumorBoardParticipantOutcome.skipped ? 'true' : 'false'}</td>
                  <td>{tumorBoardParticipantOutcome.opinionSummary}</td>
                  <td>{tumorBoardParticipantOutcome.active ? 'true' : 'false'}</td>
                  <td>{tumorBoardParticipantOutcome.cursor}</td>
                  <td>{tumorBoardParticipantOutcome.lastUpdated}</td>
                  <td>{tumorBoardParticipantOutcome.microSec}</td>
                  <td>{tumorBoardParticipantOutcome.timestampEntry}</td>
                  <td>
                    {tumorBoardParticipantOutcome.boardMember ? (
                      <Link to={`/tumor-board-occurrence-participant/${tumorBoardParticipantOutcome.boardMember.id}`}>
                        {tumorBoardParticipantOutcome.boardMember.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {tumorBoardParticipantOutcome.occurrence ? (
                      <Link to={`/tumor-board-occurrence/${tumorBoardParticipantOutcome.occurrence.id}`}>
                        {tumorBoardParticipantOutcome.occurrence.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {tumorBoardParticipantOutcome.patient ? (
                      <Link to={`/tumor-board-patient/${tumorBoardParticipantOutcome.patient.id}`}>
                        {tumorBoardParticipantOutcome.patient.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/tumor-board-participant-outcome/${tumorBoardParticipantOutcome.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/tumor-board-participant-outcome/${tumorBoardParticipantOutcome.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/tumor-board-participant-outcome/${tumorBoardParticipantOutcome.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.tumorBoardParticipantOutcome.home.notFound">
                No Tumor Board Participant Outcomes found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={tumorBoardParticipantOutcomeList && tumorBoardParticipantOutcomeList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TumorBoardParticipantOutcome;
